import React, { memo } from 'react';
import * as styles from './Skeleton.css';

interface Props {
  loading: boolean;
  numberOfCharacters: number;
  children: any; // TODO_TYPE
}

const Skeleton = ({
  children,
  loading = false,
  numberOfCharacters = 10,
}: Props) => {
  if (loading) {
    return (
      <div className={styles.skeleton}>
        {Array(numberOfCharacters + 1).join('_')}
      </div>
    );
  }

  return children;
};

export default memo(Skeleton);
